import { createAction } from '@reduxjs/toolkit'
import makeFetchSlice from '../makeFetchSlice'

export const globalContentActionCreator = createAction('global/content')

const globalSlice = makeFetchSlice('global', globalContentActionCreator)

export default globalSlice.reducer
